import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lobby",
  "use": "lobby-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"lobby\"><defs><style>#lobby .cls-1{fill:#fff;stroke-width:0}</style></defs><path d=\"M33.7 165.9 0 132.2V67.7L66.9 1.5V68l-33.2 33.3v64.6M133.1 197.2l-33.5-31.3L67 198.5l-32-31.3L99.4 102l64.9 63.9-31 31.3zM200 132.2l-33.7 33.7v-64.6l-33.2-33.2V1.6L200 67.7v64.6z\" class=\"cls-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol